/**
 * Document-level click handler for custom variant buttons in product cards.
 * Uses event delegation so it works for both server-rendered and
 * dynamically-injected product cards (e.g. product recommendations).
 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.custom-unified-variant-label');
  if (!btn) return;

  var card = btn.closest('product-card');
  if (!card) return;

  var variantId = Number(btn.dataset.variantId);
  if (!variantId) return;

  var dataEl = card.querySelector('.custom-variant-data');
  if (!dataEl) return;

  var variants = JSON.parse(dataEl.textContent);
  var variant = variants.find(function (v) {
    return v.id === variantId;
  });
  if (!variant) return;

  var buttons = card.querySelectorAll('.custom-unified-variant-label');
  buttons.forEach(function (b) {
    b.classList.remove('custom-unified-variant-label--active');
    b.setAttribute('aria-pressed', 'false');
  });
  btn.classList.add('custom-unified-variant-label--active');
  btn.setAttribute('aria-pressed', 'true');

  if (variant.image_url) {
    var img = card.querySelector('.custom-unified-card-image-wrapper img');
    if (img) {
      img.src = variant.image_url;
      img.srcset = '';
      img.alt = variant.image_alt;
    }
  }

  var priceEl = card.querySelector('.custom-unified-current-price');
  if (priceEl) {
    priceEl.textContent = variant.price;
  }

  var compareEl = card.querySelector('.custom-unified-compare-price');
  if (variant.compare_at_price > 0 && variant.compare_at_price_formatted !== variant.price) {
    if (!compareEl) {
      compareEl = document.createElement('span');
      compareEl.className = 'custom-unified-compare-price';
      priceEl.parentNode.appendChild(compareEl);
    }
    compareEl.textContent = variant.compare_at_price_formatted;
    compareEl.style.display = '';
  } else if (compareEl) {
    compareEl.style.display = 'none';
  }

  var badge = card.querySelector('.custom-unified-badge');
  if (!variant.available) {
    card.classList.add('is-out-of-stock');
    if (badge) {
      badge.className = 'custom-unified-badge out-of-stock';
      badge.textContent = card.dataset.soldOutText;
    } else {
      badge = document.createElement('span');
      badge.className = 'custom-unified-badge out-of-stock';
      badge.textContent = card.dataset.soldOutText;
      card.querySelector('.custom-unified-card-image-wrapper').prepend(badge);
    }
  } else {
    card.classList.remove('is-out-of-stock');
    if (variant.compare_at_price > 0 && variant.compare_at_price_formatted !== variant.price) {
      var priceCents = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
      var compareCents = parseFloat(variant.compare_at_price_formatted.replace(/[^0-9.]/g, ''));
      var discount = Math.round((1 - priceCents / compareCents) * 100);
      if (badge) {
        badge.className = 'custom-unified-badge sale';
        badge.textContent = discount + '% ' + (card.dataset.offText || 'OFF');
      } else {
        badge = document.createElement('span');
        badge.className = 'custom-unified-badge sale';
        badge.textContent = discount + '% ' + (card.dataset.offText || 'OFF');
        card.querySelector('.custom-unified-card-image-wrapper').prepend(badge);
      }
    } else if (badge) {
      badge.remove();
    }
  }

  var cardLink = card.querySelector('.custom-unified-card-link');
  var titleLink = card.querySelector('.custom-unified-card-title-link');
  if (variant.url) {
    if (cardLink) cardLink.href = variant.url;
    if (titleLink) titleLink.href = variant.url;
  }
});
